import(/* webpackMode: "eager", webpackExports: ["Hydrate","useHydrate"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/Hydrate.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/isRestoring.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider","defaultContext","useQueryClient"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["unstable_batchedUpdates"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/reactBatchedUpdates.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/useIsMutating.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/useMutation.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/useQueries.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/opt/app/node_modules/@tanstack/react-query/build/lib/useQuery.mjs");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/icons/eu-funds.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/icons/europe-flag.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/icons/logo-poland.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/icons/republic-of-poland.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/doodles/crown.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/doodles/exclamation-doodle-lines-2.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/doodles/exclamation-doodle-lines.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/circle-1.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/circle-2.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/circle-3.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/circle-4.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/circle-5.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/client-opinions-highlight.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/creme-de-la-creme-highlight.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/line-1-straight.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/line-3-cross-2.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/line-3-cross.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/line-8.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/highlights/violet-text-highlight.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/arrow-right-grey.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/arrow-up-right-grey.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/brand/iso-gray.png");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/development.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/magic.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/nocode.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/pen.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/sh-logo-black.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/sh-logo-white.svg");
;
import(/* webpackMode: "eager" */ "/opt/app/public/assets/images/icons/user.svg");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationMarker"] */ "/opt/app/src/rsc/client/HydrationMarker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NumberReveal"] */ "/opt/app/src/rsc/client/NumberReveal.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/src/rsc/client/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/opt/app/src/rsc/client/Slider/Slider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/src/rsc/client/TextDecorationPng.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/src/rsc/client/TextDecorationSvg.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/src/rsc/client/VideoBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMarkVideo"] */ "/opt/app/src/rsc/layout/FooterMarkVideo.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderCtaReveal"] */ "/opt/app/src/rsc/layout/HeaderCtaReveal.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderShell"] */ "/opt/app/src/rsc/layout/HeaderShell.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/opt/app/src/rsc/layout/LanguageSwitcher.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MegaMenu"] */ "/opt/app/src/rsc/layout/MegaMenu.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroParticlesLazy"] */ "/opt/app/src/rsc/sections/IndustriesHeroSection/HeroParticlesLazy.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuoteScrub"] */ "/opt/app/src/rsc/sections/IndustriesTestimonialSection/QuoteScrub.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QAAccordion"] */ "/opt/app/src/rsc/sections/QASection/QAAccordion.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PainColumns"] */ "/opt/app/src/rsc/sections/SliderWithGlassItems/PainColumns.client.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/src/rsc/ui/Link.client.tsx");
